<template>
  <div id="PrintPage" class="myContainer d-none">
    <div class="d-print-none titleBar">
      <div>
        <v-btn
          v-if="items.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="myContainer printHearder">
      <div class="Headerinfo">
        <h3>{{ StoreInfo.UserBranch }}</h3>
        <h5>{{ StoreInfo.phone }}</h5>
        <h5>{{ `${StoreInfo.country}-${StoreInfo.City}` }}</h5>
        <!-- <h5>{{ JSON.stringfy(StoreInfo) }}</h5> -->
      </div>
    </div>
    <div class="myContainer printHearder2">
      <div class="Headerinfo">
        <div id="clientInf">
          <div class="myTitle">ORDER:</div>
          <div class="myContent">{{ _code }}</div>
        </div>
        <div id="clientInf">
          <div class="myTitle">DATE:</div>
          <div class="myContent">{{ client.date }}</div>
        </div>
        <!-- <h5>ORDER: {{ _code }}</h5>
        <h5>Date: {{ client.date }}</h5> -->
      </div>
      <div class="Headerinfo">
        <!-- <h3>CLIENT: {{ client.Name }}</h3>
          <h5>PHONE: {{ client.phone }}</h5> -->
        <div id="clientInf">
          <div class="myTitle">CLIENT:</div>
          <div class="myContent">{{ client.Name }}</div>
        </div>
        <div id="clientInf">
          <div class="myTitle">PHONE:</div>
          <div class="myContent">{{ client.phone }}</div>
        </div>
        <!-- <h5>{{ client }}</h5> -->
      </div>
      <div class="Headerinfo">
        <div id="clientInf">
          <div class="myTitle">TOTAL:</div>
          <div class="myTitle">
            {{ totalPrice.toLocaleString() }}
            <span>{{ StoreInfo.CashBase | MoneySigns }}</span>
          </div>
        </div>

        <div id="clientInf">
          <div class="myTitle">Discount:</div>
          <div class="myTitle">
            {{
              client.Discount
                ? client.Discount.toLocaleString()
                : client.Discount
            }}
            <span>{{ StoreInfo.CashBase | MoneySigns }}</span>
          </div>
        </div>
        <div id="clientInf">
          <div class="myTitle">PAID:</div>
          <div class="myTitle">
            {{ client.Amount ? client.Amount.toLocaleString() : client.Amount }}
            <span>{{ StoreInfo.CashBase | MoneySigns }}</span>
          </div>
        </div>
        <div id="clientInf">
          <div class="myTitle">BALANCE:</div>
          <div class="myTitle">
            {{ client.Remain ? client.Remain.toLocaleString() : client.Remain }}
            <span>{{ StoreInfo.CashBase | MoneySigns }}</span>
          </div>
        </div>
        <!-- <h5>
          DUE AMOUNT:
        
        </h5>
        <h5>Discount: {{ client.Discount }}</h5>
        <h5>PAID AMOUNT: {{ client.Amount.toLocaleString() }}</h5>
        <h5>
          BALANCE:
          {{ client.Remain ? client.Remain.toLocaleString() : client.Remain }}
        </h5> -->

        <!-- <h5>Kenya Nairobi</h5> -->
      </div>
    </div>
    <BasePureTable
      key="PrintTable"
      :myStyle="TableStyle"
      :headers="headers"
      :items="items"
    >
      <template v-if="StockType == 'retail'" #[`coll.QTY`]="{row}">
        {{ `${row.qty.toLocaleString()} PCS` }}
      </template>
      <template v-else #[`coll.QTY`]="{row}">
        {{ `${row.qty.toLocaleString()} ${row.UnitType}` }}
      </template>
      <!-- <template v-if="StockType == 'retail'" #coll.Price="{row}">
        <div>
          {{ (row.price / row.UnitQty).toFixed(1).toLocaleString() }}
          <span>{{ StoreInfo.CashBase | MoneySigns }}</span>
        </div>
      </template> -->
      <template #[`coll.Price`]="{row}">
        {{ row.price.toLocaleString() }}
      </template>
      <template #tableFoot>
        <td></td>
        <td>{{ totalQty.toLocaleString() }}</td>
        <td>
          {{ totalPrice.toLocaleString() }}
          <span>{{ StoreInfo.CashBase | MoneySigns }}</span>
        </td>
      </template>
    </BasePureTable>
  </div>
  <!-- </v-dialog> -->
  <!-- </v-container> -->
</template>
<script>
import { Printd } from "printd";

import { TableCSS } from "./princssModule";

export default {
  props: {
    clearData: {
      type: Function,
      required: true,
    },
    OrderPrint: {
      type: String,
      required: true,
    },
    StoreInfo: {
      type: Object,
      default: () => ({ UserBranch: "", country: "", City: "", phone: "" }),
    },
    client: {
      type: Object,
      default: () => ({
        Name: "",
        phone: "",
        Amount: 0,
        Discount: 0,
        // OrderPrint: "",
        date: "",
      }),
    },
    value: { type: Boolean, default: false },
    StockType: { type: String, required: true },
    items: { type: Array, required: true },
  },
  watch: {
    value(v) {
      if (v) {
        this.$nextTick(() => {
          this.PrintPage();
        });
      }
    },
  },
  computed: {
    _code() {
      return this.OrderPrint;
    },
    totalPrice() {
      return this.items.reduce((t, item) => {
        return (t += item.price * item.qty);
      }, 0);
    },
    totalQty() {
      return this.items.reduce((t, item) => {
        return (t += item.qty);
      }, 0);
    },
  },
  data() {
    return {
      myDialog: false,
      TableStyle: {
        headStyle: {
          "my-table-border": true,
          "my-table-content-centen": false,
          //   yellow: true
        },
        bodyStyle: {
          "my-table-border": true,
          "my-table-content-centen": false,
        },
      },
      //   dialog: false,
      headers: [
        {
          text: "Item",
          align: "left",
          value: "InvName",
          class: "green darken-3 white--text",
        },
        {
          text: "QTY",
          value: "qty",
          class: "green darken-3 white--text",
        },

        {
          text: "Price",
          value: "price",
          class: "green darken-3 white--text",
        },
      ],
    };
  },
  methods: {
    PrintPage() {
      const myStyle = [TableCSS];

      const d = new Printd();
      d.print(
        document.getElementById("PrintPage"),
        myStyle,
        [],
        ({ launchPrint }) => {
          //   console.log(this.OrderPrint);
          launchPrint();
          this.$emit("input", false);
          this.clearData();
        }
      );
    },
  },
};
</script>
<style scoped>
#PrintPage {
  padding: 10px 15px;
  height: 100%;
  flex-direction: column;
  background-color: white;
  font-family: "Courier New", Courier, monospace;
}
.myContainer {
  display: flex;
}
.printHearder {
  background-color: teal;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  flex-wrap: wrap;
  justify-content: center;
  width: 90%;
  align-self: center;
}
.printHearder .Headerinfo {
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-bottom: 5px;
  color: black;
  font-weight: bold;
  max-width: 40%;
  align-items: center;
  line-height: 20px;
  /* flex-grow: 2; */
}
.printHearder2 {
  /* flex-direction: ; */
  /* margin-top: 10px; */
  /* padding: 5px 15px; */
  margin-top: 5px;
  background-color: teal;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  width: 90%;
  align-self: center;
}
.printHearder2 .Headerinfo {
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-bottom: 5px;
  color: white;
  justify-content: center;
  max-width: 40%;
  /* line-height: 18px; */
  padding-right: 10px;
  padding-left: 10px;
}
#clientInf {
  display: flex;
  flex-direction: row;
}
#clientInf .myTitle {
  font-weight: bold;
  margin-right: 2px;
  flex-wrap: nowrap;
}
#clientInf .myContent {
  flex-wrap: wrap;
  font-weight: lighter;
  text-align: center;
}

.Headerinfo h3,
.Headerinfo h5 {
  line-height: 0.5cm;
  font-weight: bold;
}

.titleBar {
  display: flex;
  flex-direction: row-reverse;
  background-color: rgb(3, 3, 129);
  height: 40px;
  align-items: center;
  padding-right: 15px;
  width: 90%;
  align-self: center;
  margin-bottom: 5px;
}
</style>
